import { render } from "./PasswordModal.vue?vue&type=template&id=5bb4819c&ts=true"
import script from "./PasswordModal.vue?vue&type=script&lang=ts"
export * from "./PasswordModal.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__